export default {
  data () {
    return {
      showArrow: false,
      hideArrow: false
    }
  },
  methods: {
    scrolled () {
      const scrollSection = document.getElementsByClassName('scrollable')[0]
      if (!scrollSection || typeof scrollSection === 'undefined') {
        return
      }
      if (scrollSection.offsetHeight + scrollSection.scrollTop > scrollSection.scrollHeight - 60) {
        this.hideArrow = true
      } else {
        this.hideArrow = false
      }
    },
    onResize () {
      const extension = document.getElementsByClassName('v-toolbar__extension')[0]
      const content = document.getElementsByClassName('v-toolbar__content')[0]
      var totalHeight =
        window.innerHeight -
        (typeof content !== 'undefined' ? content.offsetHeight : 0) -
        (typeof extension !== 'undefined' ? extension.offsetHeight : 0)
      document.getElementById('flex-section').style.maxHeight =
        totalHeight + 'px'
    },
    hasScrollbar () {
      this.$nextTick(() => {
        const scrollSection = document.getElementsByClassName('scrollable')[0]
        if (!scrollSection || typeof scrollSection === 'undefined' || !scrollSection.childNodes.length) {
          this.showArrow = false
          return
        }
        var heightOfChildren = 0
        const children = scrollSection.childNodes
        for (var i = 0; i < children.length; i++) {
          var node = children[i]
          if (node.localName === 'div') {
            heightOfChildren += node.offsetHeight
          }
        }
        this.showArrow = (heightOfChildren > scrollSection.offsetHeight)
      })
    }
  },
  beforeDestroy () {
    const scrollSection = document.getElementsByClassName('scrollable')[0]
    if (!scrollSection || typeof scrollSection === 'undefined') {
      return
    }
    scrollSection.removeEventListener('scroll', this.scrolled)
  },
  mounted () {
    const scrollSection = document.getElementsByClassName('scrollable')[0]
    if (!scrollSection || typeof scrollSection === 'undefined') {
      return
    }
    scrollSection.addEventListener('scroll', this.scrolled)
    this.hasScrollbar()
  }
}
